import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft, GanttChartSquare } from 'lucide-react';
import { requireFeature } from '@/common/utils/requireFeature';
import { usePermissions } from '@/common/hooks/usePermissions';
import { Button } from '@/components/ui/button';
import { ProjectTemplatesList } from '@/features/tech-systems/project-templates/components/ProjectTemplatesList';
import {
  canManageProjectTemplates,
  canViewProjectTemplates,
} from '@/features/tech-systems/project-templates/utils/access';

export const Route = createFileRoute('/_authenticated/tech-systems/templates/')({
  beforeLoad: () => requireFeature('TECH_SYSTEMS'),
  component: ProjectTemplatesPage,
});

function ProjectTemplatesPage() {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const canView = canViewProjectTemplates(hasPermission);
  const canManage = canManageProjectTemplates(hasPermission);

  if (!canView) {
    return (
      <div className="space-y-4 p-6">
        <h1 className="text-2xl font-semibold">Templates de projeto</h1>
        <p className="text-sm text-muted-foreground">
          Você não tem permissão para acessar os templates de projeto dos Sistemas TEC.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-semibold">
            <GanttChartSquare className="h-7 w-7 text-primary" />
            Templates de projeto
          </h1>
          <p className="text-sm text-muted-foreground">
            Modelos de cronograma com tarefas encadeadas em dias úteis, aplicáveis ao quadro de
            projetos de um sistema.
          </p>
        </div>
        <Button variant="outline" size="sm" asChild>
          <Link to="/tech-systems/projects">
            <ArrowLeft className="h-4 w-4" />
            Gestão de projetos
          </Link>
        </Button>
      </div>

      <ProjectTemplatesList
        canManage={canManage}
        onOpen={(templateId) =>
          navigate({ to: '/tech-systems/templates/$id', params: { id: templateId } })
        }
      />
    </div>
  );
}
